import Vue from 'vue'
import apiList from '@/service/apiList'
import { Message } from 'element-ui'
import { rejects } from 'assert'
// 获取商城分类
function getBillList (params) {
  params.shop_id = localStorage.getItem('shop_id')
  return new Promise((resolve) => {
    Vue.prototype.$api.post(apiList.billList, params)
      .then(function (res) {
        resolve(res.data)
      })
      .catch(function (err) {
        console.log(err)
      })
  })
}
// 对账列表
function getAccountlist (params) {
  params.shop_id = localStorage.getItem('shop_id')
  return new Promise((resolve, reject) => {
    Vue.prototype.$api.get(apiList.accountlist, params)
      .then(function (res) {
        resolve(res)
      })
      .catch(function (err) {
        reject(err)
        console.log(err)
      })
  })
}
// 对账报表筛选条件
function getAccountFilter (params) {
  params.shop_id = localStorage.getItem('shop_id')
  return new Promise((resolve, reject) => {
    Vue.prototype.$api.get(apiList.accountfilter, params)
      .then(function (res) {
        resolve(res)
      })
      .catch(function (err) {
        reject(err)
        console.log(err)
      })
  })
}
// 导出对账
function exportAccountData (params) {
  return new Promise((resolve) => {
    Vue.prototype.$api.get(apiList.exportAccountData, params)
      .then(function (res) {
        if (res.message === 'Success') {
          // Message.success('导出对账报表成功，请在邮箱中查收!今日已导出' + res.data + '次')
          Message.success('对账报表导出成功，请在报表中心查看下载！今日已导出' + res.data + '次')
        }
        resolve(res.data)
      })
      .catch(function (err) {
        console.log(err)
      })
  })
}
// 获取报表的总数据
function getReportCollectTotal (params) {
  return new Promise((resolve) => {
    Vue.prototype.$api.get(apiList.getReportCollectTotal, params)
      .then(function (res) {
        if (res.code === 200) {
          resolve(res.data)
        } else {
          resolve(res)
        }
      })
      .catch(function (err) {
        console.log(err)
      })
  })
}
// 获取详情 表
function getReportCollectDetail (params) {
  return new Promise((resolve) => {
    Vue.prototype.$api.get(apiList.getReportCollectDetail, params)
      .then(function (res) {
        if (res.code === 200) {
          resolve(res.data)
        } else {
          resolve(res)
        }
      })
      .catch(function (err) {
        console.log(err)
      })
  })
}
// 获取报表的列表数据 下拉
function getReportCollectList (params) {
  return new Promise((resolve) => {
    Vue.prototype.$api.get(apiList.getReportCollectList, params)
      .then(function (res) {
        if (res.code === 200) {
          resolve(res.data)
        } else {
          resolve(res)
        }
      })
      .catch(function (err) {
        console.log(err)
      })
  })
}
// 获取报表的详情数据  查看
function getReportCollectInfo (params) {
  return new Promise((resolve) => {
    Vue.prototype.$api.get(apiList.getReportCollectInfo, params)
      .then(function (res) {
        if (res.code === 200) {
          resolve(res.data)
        } else {
          resolve(res)
        }
      })
      .catch(function (err) {
        console.log(err)
      })
  })
}
export {
  getBillList,
  exportAccountData,
  getAccountlist,
  getAccountFilter,
  getReportCollectTotal,
  getReportCollectDetail,
  getReportCollectList,
  getReportCollectInfo
}



// WEBPACK FOOTER //
// ./src/models/reportModel.js